export const ALPHANUM_DASH = /^[a-zA-Z0-9-]*$/
